import { useEffect } from "react";
import Checkbox from "../../Checkbox/Checkbox";
import { useSectionContext } from "../context/SectionContext";

/**
 * DisableSectionFlag is a component that provides a toggle to enable/disable
 * an entire form section.
 */
const DisableSectionFlag = ({
  name,
  label,
  sectionName,
  value,
  onChange,
  disabled,
}: {
  name: string;
  label: string;
  sectionName: string;
  value: boolean;
  onChange: () => void;
  disabled?: boolean;
}) => {
  // Use the section name from props
  const { toggleSectionDisabled, isSectionDisabled } = useSectionContext();

  // Check the current disabled state from context
  const sectionDisabledInContext = isSectionDisabled(sectionName);

  // Synchronize the toggle value with the section disabled state on mount and when value changes
  useEffect(() => {
    // If the toggle value doesn't match the context's disabled state,
    // update the context to match the toggle
    if (value !== sectionDisabledInContext) {
      toggleSectionDisabled(sectionName, value);
    }
  }, [value, sectionName, sectionDisabledInContext, toggleSectionDisabled]);

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Call the original onChange to update the toggle state
    onChange();

    // Update the section disabled state in context
    toggleSectionDisabled(sectionName, !value);
  };

  return (
    <div className="section-toggle-container">
      <Checkbox
        name={name}
        label={label}
        checked={value}
        onChange={handleToggle}
        disabled={disabled ?? false}
        className="align-items-center flex"
        testIdPrefix="section-toggle"
      />
    </div>
  );
};

export default DisableSectionFlag;
